import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { Row, Spin, Form, Input, Button, message } from "antd";
import Card from "components/card/Card.js";
import React, { useState } from "react";
import { Controller } from "Controller/Controller";
const ChangePassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Simulate API call
      console.log(values);

      const payload = {
        old_password: values.currentPassword,
        new_password1: values.newPassword,
        new_password2: values.confirmPassword,
      };

      const response = await Controller.changePassword(payload);
      if (response.status < 250) {
        message.success("Password changed successfully!");
        form.resetFields();
      } else {
        console.log(response.json);
        message.error(
          response.json.new_password1 ? 
          response.json.new_password1[0] :
          response.json.new_password2 ? 
          response.json.new_password2[0] :
          response.json.old_password ? 
          response.json.old_password[0] :
          response.json.detail ? 
          response.json.detail[0] :
          'Error - Failed to change password'
        );
      }

    } catch (error) {
      message.error("Failed to change password");
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <div>
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
          <SimpleGrid>
            <Card px="0px" mb="20px" style={{ minHeight: "400px" }}>
              <Flex
                align={{ sm: "flex-start", lg: "center" }}
                justify="center"
                w="100%"
                px="22px"
                pb="20px"
                mb="10px"
              >
                <Row style={{ width: "40%" }}>
                  <Form
                    form={form}
                    name="change-password"
                    onFinish={onFinish}
                    layout="vertical"
                    style={{ width: "100%" }}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <br />
                    <Form.Item
                      label="Current Password"
                      name="currentPassword"
                      rules={[
                        {
                          required: true,
                          message: "Please input your current password!",
                        },
                      ]}
                    >
                      <Input.Password placeholder="Enter current password" />
                    </Form.Item>
                    <br />
                    <Form.Item
                      label="New Password"
                      name="newPassword"
                      rules={[
                        {
                          required: true,
                          message: "Please input your new password!",
                        },
                        {
                          min: 8,
                          message: "Password must be at least 8 characters!",
                        },
                      ]}
                    >
                      <Input.Password placeholder="Enter new password" />
                    </Form.Item>
                    <br />
                    <Form.Item
                      label="Confirm New Password"
                      name="confirmPassword"
                      dependencies={["newPassword"]}
                      rules={[
                        {
                          required: true,
                          message: "Please confirm your new password!",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              getFieldValue("newPassword") === value
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("The two passwords do not match!")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password placeholder="Confirm new password" />
                    </Form.Item>
                    <br />

                    <Form.Item>
                      <Row justify={"center"}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={loading}
                        >
                          {loading ? <Spin size="small" /> : "Change Password"}
                        </Button>
                      </Row>
                    </Form.Item>
                  </Form>
                </Row>
              </Flex>
            </Card>
          </SimpleGrid>
        </Box>
      </div>
    </React.Fragment>
  );
};

export default ChangePassword;
